import { newModal } from "@js/helpers/state.js";
import { CE_MODAL_INSERT_FORM_OPEN } from "@js/actions/studio/campaign_content_section/modal_insert_form.js";

export default (state = {}, action) => {
  switch (action.type) {
    case CE_MODAL_INSERT_FORM_OPEN:
      return newModal(state, "insert_form", {
        forms: state.library.forms,
        format: action.format,
      });
    default:
      return state;
  }
};
